import { CALL_API } from "../api.middleware";
import {
  CLEAR_NEW_SUBSCRIBER_DATA,
  GET_AADHAAR_DETAILS_SUCCESS,
  GET_BANK_DETAILS,
  GET_FATCA_DETAILS,
  GET_FATCA_DETAILS_SUCCESS,
  GET_KYC_DETAILS,
  GET_NOMINEE_LIST,
  GET_NPS_FUND_INVESTMENT_CHOICES,
  GET_NPS_SCHEME_DETAILS,
  GET_PERSONAL_DETAILS,
  GET_PREVIEW,
  GET_PREVIEW_SUCCESS,
  SAVE_BANK_DETAILS,
  SAVE_BANK_DETAILS_SUCCESS,
  SAVE_DOCUMENTS,
  SAVE_DOCUMENTS_SUCCESS,
  SAVE_FATCA_DETAILS,
  SAVE_FATCA_DETAILS_SUCCESS,
  SAVE_KYC_DETAILS,
  SAVE_KYC_DETAILS_SUCCESS,
  SAVE_NOMINEE_DETAILS,
  SAVE_NOMINEE_DETAILS_SUCCESS,
  SAVE_NPS_SCHEME_DETAILS,
  SAVE_NPS_SCHEME_DETAILS_SUCCESS,
  SAVE_PERSONAL_DETAILS,
  STORE_ACK_NUMBER,
  STORE_ACCOUNT_TYPE,
  STORE_KYC_KTRACK_DETAILS,
  STORE_STEP,
  STORE_SUBSCRIBER_DATA,
} from "../types/newSubscriber";

export const setCurrentStep = (step) => {
  return {
    type: STORE_STEP,
    body: step,
  };
};

/**
 ****** NPS Subscriber Getting APIs ******
 */

export const redirectToDigilocker = () => {
  return async (dispatch) => {
    try {
      const response = await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/distributor/redirectToDigilcker",
          method: "GET",
        },
      });
      const { data = {} } = response;
      const { redirectUrl = "" } = data;
      !!redirectUrl && (window.location.href = redirectUrl);
    } catch (error) {
      alert(error);
    }
  };
};

export const getPersonalDetails = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/GetPersonalDetails",
          body: body,
          method: "POST",
          // types: [GET_PERSONAL_DETAILS, GET_PERSONAL_DETAILS_SUCCESS],
          types: [GET_PERSONAL_DETAILS],
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const getKycDetails = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          body,
          isNpsSubscriber: true,
          url: "/subscriberJourney/GetKycDetails",
          method: "POST",
          // types: [GET_KYC_DETAILS, GET_KYC_DETAILS_SUCCESS],
          types: [GET_KYC_DETAILS],
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const getFatcaDetails = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          body,
          isNpsSubscriber: true,
          url: "/subscriberJourney/GetFatcaDetails",
          method: "POST",
          types: [GET_FATCA_DETAILS, GET_FATCA_DETAILS_SUCCESS],
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const getAccountType = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          body,
          isNpsSubscriber: true,
          url: "/subscriberJourney/GetAccountType",
          method: "POST",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const getBankDetails = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/GetBankDetails",
          body: body,
          method: "POST",
          // types: [GET_BANK_DETAILS, GET_BANK_DETAILS_SUCCESS],
          types: [GET_BANK_DETAILS],
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const getDetailsFromPincode = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/GetStateDistrictDetailsfromPincode",
          body: body,
          method: "POST",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const getBankDetailsFromIFSC = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/GetBankDetailsFromIFCSMICR",
          body: body,
          method: "POST",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const getNomineeList = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/GetNomineeDetails",
          method: "POST",
          body: body,
          // types: [GET_NOMINEE_LIST, GET_NOMINEE_LIST_SUCCESS],
          types: [GET_NOMINEE_LIST],
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};
export const getShortUrl = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/GenerateShortUrl",
          method: "POST",
          body: body,
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const getLifeCyclesBySchemePreference = () => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/GetLifeCyclesBySchemePreferenceType",
          method: "GET",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};
export const getCountriesAndState = () => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/CountriesAndStates",
          method: "GET",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};
export const getPOPbankNames = () => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/GetPOPBankNames",
          method: "GET",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const getMasterData = () => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/GetMasterData",
          method: "GET",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const getPfmNames = () => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/GetPfmNames",
          method: "GET",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const getRegdSchemes = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          // isFixtureEnabled: true,
          fixtureJson: "investmentDetails.json",
          url: "/subscriberJourney/GetRegSchemeNames",
          method: "POST",
          body,
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const getFundChoices = () => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/GetFundChoices",
          method: "GET",
          // types: [
          //   GET_NPS_FUND_INVESTMENT_CHOICES,
          //   GET_NPS_FUND_INVESTMENT_CHOICES_SUCCESS,
          // ],
          types: [GET_NPS_FUND_INVESTMENT_CHOICES],
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const getSchemeDetails = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/GetSchemeDetails",
          body: body,
          method: "POST",
          // types: [GET_NPS_SCHEME_DETAILS, GET_NPS_SCHEME_DETAILS_SUCCESS],
          types: [GET_NPS_SCHEME_DETAILS],
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const getAgentDetails = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subsequentContribution/agentDetails",
          body: body,
          method: "POST",
          // types: [GET_NPS_SCHEME_DETAILS, GET_NPS_SCHEME_DETAILS_SUCCESS],
          types: [GET_NPS_SCHEME_DETAILS],
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const getPortfolioDetails = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/portfolio",
          body: body,
          method: "POST",
          // types: [GET_NPS_SCHEME_DETAILS, GET_NPS_SCHEME_DETAILS_SUCCESS],
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const getEpranKit = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/GetEpranKit",
          body: body,
          method: "POST",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const completePendingRegistration = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/CompletePendingRegistration",
          body: body,
          method: "POST",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};
export const getPreview = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/GetDetailsforPreview",
          body: body,
          method: "POST",
          types: [GET_PREVIEW, GET_PREVIEW_SUCCESS],
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

/**
 ****** NPS Subscriber OTP Generation and Verification ******
 */

export const generateMobileOtp = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/GenerateOtp",
          body: body,
          method: "POST",
        },
      });
    } catch (e) {
      // alert(e);
    }
  };
};

export const validateMobileOtp = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/ValidateOtp",
          body: body,
          method: "POST",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const sendRegistrationOtp = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/sendRegistrationOtp",
          body: body,
          method: "POST",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const validateRegistrationOtp = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/validateRegistrationOtp",
          body: body,
          method: "POST",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const generateEmailOtp = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/GenerateEmailOTPwithACK",
          body: body,
          method: "POST",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};
export const validateEmailOtp = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/ValidateEmailOTPwithACK",
          body: body,
          method: "POST",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

//Miscellaneous

export const getPendingSubscribers = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/NPSMFDRegPendingSubscribers",
          body: body,
          method: "POST",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const getActiveSubscribers = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/NPSMFDRegCompletedSubscribers",
          body: body,
          method: "POST",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

/**
 ******* NPS Subscriber Saving APIs ********
 */

export const saveBasicDetails = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/SaveBasicDetails",
          body: body,
          method: "POST",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};
// export const verifyPanDetails = (body) => {
//   return async (dispatch) => {
//     try {
//       return await fetch("https://ping.arya.ai/api/v2/ckyc", {
//         method: "post",
//         headers: new Headers({
//           Authorization: "c920ffcef36b3d9df32ee0e21fd8aa1e",
//           "Content-Type": "application/json",
//         }),
//         body: JSON.stringify(body),
//       });
//     } catch (e) {
//       alert(e);
//     }
//   };
// };

export const getCkycDetails = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/GetEKYCDetails",
          body: body,
          method: "POST",
          // types: [SAVE_PERSONAL_DETAILS, SAVE_PERSONAL_DETAILS_SUCCESS],
          // types: [SAVE_CKYC_DETAILS],
          savePayload: true,
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const validatePan = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/validatedPan",
          body: body,
          method: "POST",
          // types: [SAVE_PERSONAL_DETAILS, SAVE_PERSONAL_DETAILS_SUCCESS],
          // types: [SAVE_CKYC_DETAILS],
          savePayload: true,
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const savePersonalDetails = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/SavePersonalDetails",
          body: body,
          method: "POST",
          // types: [SAVE_PERSONAL_DETAILS, SAVE_PERSONAL_DETAILS_SUCCESS],
          types: [SAVE_PERSONAL_DETAILS],
          savePayload: true,
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const saveAccountType = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/SaveAccountType",
          body: body,
          method: "POST",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const saveKycDetails = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/SaveKYCDetails",
          body: body,
          method: "POST",
          types: [SAVE_KYC_DETAILS, SAVE_KYC_DETAILS_SUCCESS],
          savePayload: true,
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const saveBankDetails = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/SaveBankDetails",
          body: body,
          method: "POST",
          types: [SAVE_BANK_DETAILS, SAVE_BANK_DETAILS_SUCCESS],
          savePayload: true,
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};
export const savePennyDetails = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/pennyDrop",
          body: body,
          method: "POST",
          // types: [SAVE_PENNY_DETAILS , SAVE_PENNY_DETAILS_SUCCESS],
          savePayload: true,
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const saveNomineeDetails = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/SaveNominationDetails",
          body: body,
          method: "POST",
          types: [SAVE_NOMINEE_DETAILS, SAVE_NOMINEE_DETAILS_SUCCESS],
          savePayload: true,
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const saveFatcaDetails = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/SaveFatcaDetails",
          body: body,
          method: "POST",
          types: [SAVE_FATCA_DETAILS, SAVE_FATCA_DETAILS_SUCCESS],
          savePayload: true,
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const saveSchemeDetails = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/SaveSchemeDetails",
          body: body,
          method: "POST",
          types: [SAVE_NPS_SCHEME_DETAILS, SAVE_NPS_SCHEME_DETAILS_SUCCESS],
          savePayload: true,
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const saveDocuments = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/SavePhotoAndSignatureDetails",
          body: body,
          method: "POST",
          types: [SAVE_DOCUMENTS, SAVE_DOCUMENTS_SUCCESS],
          savePayload: true,
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const saveEpranKit = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/SaveEpranKit",
          body: body,
          method: "POST",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const saveServiceCharges = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subsequentContribution/serviceCharges",
          body: body,
          method: "POST",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const sendSubContributionEmail = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subsequentContribution/sendEmail",
          body: body,
          method: "POST",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const updatepop = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/updatepop",
          body: body,
          method: "POST",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const savePendingView = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/CompletePendingView",
          body: body,
          method: "POST",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const sendMobileLink = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/SendMobileLink",
          body: body,
          method: "POST",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};
export const sendEmail = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          isNpsSubscriber: true,
          url: "/subscriberJourney/sendEmail",
          body: body,
          method: "POST",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

export const sendMail = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          url: "/send-emails",
          body: body,
          method: "POST",
        },
      });
    } catch (e) {
      alert(e);
    }
  };
};

/**
 * stores the body in the redux storage
 */

export const storeAckNumber = (body) => {
  return {
    type: STORE_ACK_NUMBER,
    body: body,
  };
};

export const storeAccountType = (body) => {
  return {
    type: STORE_ACCOUNT_TYPE,
    body: body,
  };
};

export const storeSubscriberData = (body) => {
  return {
    type: STORE_SUBSCRIBER_DATA,
    body: body,
  };
};

export const clearNewSubscriberData = () => {
  return {
    type: CLEAR_NEW_SUBSCRIBER_DATA,
  };
};

export const storeAadhaarDetails = (body) => {
  return {
    type: GET_AADHAAR_DETAILS_SUCCESS,
    body: body,
  };
};

export const storeInvestorDetails = (body) => {
  return {
    type: STORE_KYC_KTRACK_DETAILS,
    body,
  };
};
